import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { ChecklistFeesComponent } from './checklist-fees.component';

const routes: Routes = [
  { path: '', component: ChecklistFeesComponent, data: { title: 'Tagging Administration' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ChecklistFeesRoutingModule {}

@NgModule({
  imports: [
    ChecklistFeesRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [ChecklistFeesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ChecklistFeesModule {}
